import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsNavigationItemsIndexResponseType } from "~/domains";

type ParamsType = {
  companyId: string;
};

const request = async ({
  companyId,
}: ParamsType): Promise<ApisAdminOperatorsNavigationItemsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsNavigationItemsIndexResponseType>(
      `/api/admin_operators/companies/${companyId}/navigation_items`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  companyId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsNavigationItemsIndex = ({
  companyId,
  config = {},
}: PropsType): UseQueryResult<ApisAdminOperatorsNavigationItemsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAdminOperatorsNavigationItemsIndex", companyId],
    queryFn: () => request({ companyId }),
  });
};
